var render = function render(){var _vm=this,_c=_vm._self._c;return (this.selectedFilterSection !== '')?_c('IconBase',{staticClass:"filters_header_back_btn",attrs:{"icon-name":"arrow-left","width":"16","height":"16","viewBox":"0 0 16 16","title":"Назад","no-divider":true},nativeOn:{"click":function($event){return _vm.backToFiltersMenu.apply(null, arguments)}}},[_c('IconArrowLeft')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }